export default __webpack_public_path__ + "_/images/app/ios/ios-ru-3-627dc2a0aa260ec1e6f6a43e3027fca79b8d85f1da787ff4c7d761b11f0a4dee.jpg";